export default {
    CONTEXT_MONEY_LABEL: 'Desired Annual Income',
    DEFERRAL_PERIOD_LABEL: 'Deferral period (roll-up % applied each year of the deferral period)',

    DEFAULT_ANNUAL_INCOME: '40000',
    DEFAULT_DEFERRAL_PERIOD: 7,
};
